// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shift planning page (react-big-calendar). Everything is scoped under .shift-planning.
   --sp-warning / --sp-error / --sp-on-color are set inline from the antd theme tokens. */

/* ─── Toolbar ──────────────────────────────────────────────────────────── */

.shift-planning .shift-planning__filter-buttons {
  display: flex;
  gap: var(--ds-space-2);
  min-width: 0;
}

.shift-planning .shift-planning__filter-buttons > * {
  flex: 1 1 0;
  min-width: 0;
}

.shift-planning .shift-planning__filter-button {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
}

.shift-planning .shift-planning__ellipsis {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Badges wrap their button: let the button fill the badge's share of the row */
.shift-planning .page-toolbar__actions > .ant-badge {
  display: flex;
}

.shift-planning .page-toolbar__actions > .ant-badge > .ant-btn,
.shift-planning .page-toolbar__actions > .ant-btn {
  width: 100%;
  min-height: 40px;
}

@media (max-width: 767.98px) {
  /* Icon buttons share one row, "Add Shift" takes its own full-width row */
  .shift-planning .page-toolbar__actions > .shift-planning__add {
    flex: 1 1 100%;
  }
}

@media (min-width: 768px) {
  .shift-planning .page-toolbar__filters > .shift-planning__filter-buttons {
    flex: 0 1 auto;
  }

  .shift-planning .page-toolbar__actions > .ant-badge > .ant-btn,
  .shift-planning .page-toolbar__actions > .ant-btn {
    width: auto;
  }
}

/* ─── Calendar frame ───────────────────────────────────────────────────── */

.shift-planning .shift-planning__calendar {
  background: var(--ds-surface);
  border-radius: var(--ds-radius-lg);
  padding: var(--ds-space-2);
  box-shadow: var(--ds-shadow-xs);
}

.shift-planning .rbc-toolbar {
  gap: var(--ds-space-2);
}

.shift-planning .rbc-event,
.shift-planning .rbc-event-label {
  overflow-wrap: anywhere;
}

.shift-planning .rbc-addons-dnd .rbc-addons-dnd-resizable {
  width: 100%;
}

@media (max-width: 767.98px) {
  .shift-planning .shift-planning__calendar {
    padding: var(--ds-space-1);
  }

  /* Compact toolbar: period label on top, then navigation and view switch, each full width */
  .shift-planning .rbc-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .shift-planning .rbc-toolbar .rbc-toolbar-label {
    order: -1;
    padding: 0;
    font-weight: 600;
    text-align: center;
  }

  .shift-planning .rbc-toolbar .rbc-btn-group {
    display: flex;
  }

  .shift-planning .rbc-toolbar .rbc-btn-group > button {
    flex: 1 1 0;
    padding-inline: var(--ds-space-1);
  }

  /* Week and month grids keep their columns and scroll sideways inside the frame */
  .shift-planning .rbc-time-view,
  .shift-planning .rbc-month-view {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .shift-planning .is-week .rbc-time-header,
  .shift-planning .is-week .rbc-time-content {
    min-width: 640px;
  }

  .shift-planning .rbc-month-view .rbc-month-header,
  .shift-planning .rbc-month-view .rbc-month-row {
    min-width: 560px;
  }
}

/* ─── Events ───────────────────────────────────────────────────────────── */

.shift-planning .AbsentEmployee {
  border: 1px solid var(--sp-error);
  border-radius: 50%;
  padding: 2px;
}

.shift-planning .calendarEvent:has(.AbsentEmployee) {
  border: 2px solid var(--sp-error);
}

.shift-planning .DuplicateEmp {
  border: 1px solid var(--sp-warning);
  border-radius: 50%;
  padding: 2px;
}

.shift-planning .calendarEvent:has(.DuplicateEmp) {
  border: 2px solid var(--sp-warning);
}

.shift-planning .calendarEvent.shiftCancelled {
  opacity: 0.45;
  text-decoration: line-through;
  background-image: repeating-linear-gradient(
    135deg,
    transparent 0 6px,
    rgba(255, 255, 255, 0.25) 6px 12px
  );
}

.shift-planning .calendarEvent.shiftUnderstaffed {
  box-shadow: inset 0 0 0 2px var(--sp-error);
}

.shift-planning .staffCount {
  white-space: nowrap;
}

.shift-planning .staffCount.understaffed {
  background: var(--sp-error);
  color: var(--sp-on-color);
  border-radius: 8px;
  padding: 0 5px;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/shiftsPlanning/ShiftPlanning.css"],"names":[],"mappings":"AAAA;yFACyF;;AAEzF,6EAA6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yEAAyE;EACzE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA,6EAA6E;;AAE7E;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA,2FAA2F;EAC3F;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,iCAAiC;EACnC;;EAEA,iFAAiF;EACjF;;IAEE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA,6EAA6E;;AAE7E;EACE,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B;;;;GAIC;AACH;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* Shift planning page (react-big-calendar). Everything is scoped under .shift-planning.\n   --sp-warning / --sp-error / --sp-on-color are set inline from the antd theme tokens. */\n\n/* ─── Toolbar ──────────────────────────────────────────────────────────── */\n\n.shift-planning .shift-planning__filter-buttons {\n  display: flex;\n  gap: var(--ds-space-2);\n  min-width: 0;\n}\n\n.shift-planning .shift-planning__filter-buttons > * {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.shift-planning .shift-planning__filter-button {\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n}\n\n.shift-planning .shift-planning__ellipsis {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Badges wrap their button: let the button fill the badge's share of the row */\n.shift-planning .page-toolbar__actions > .ant-badge {\n  display: flex;\n}\n\n.shift-planning .page-toolbar__actions > .ant-badge > .ant-btn,\n.shift-planning .page-toolbar__actions > .ant-btn {\n  width: 100%;\n  min-height: 40px;\n}\n\n@media (max-width: 767.98px) {\n  /* Icon buttons share one row, \"Add Shift\" takes its own full-width row */\n  .shift-planning .page-toolbar__actions > .shift-planning__add {\n    flex: 1 1 100%;\n  }\n}\n\n@media (min-width: 768px) {\n  .shift-planning .page-toolbar__filters > .shift-planning__filter-buttons {\n    flex: 0 1 auto;\n  }\n\n  .shift-planning .page-toolbar__actions > .ant-badge > .ant-btn,\n  .shift-planning .page-toolbar__actions > .ant-btn {\n    width: auto;\n  }\n}\n\n/* ─── Calendar frame ───────────────────────────────────────────────────── */\n\n.shift-planning .shift-planning__calendar {\n  background: var(--ds-surface);\n  border-radius: var(--ds-radius-lg);\n  padding: var(--ds-space-2);\n  box-shadow: var(--ds-shadow-xs);\n}\n\n.shift-planning .rbc-toolbar {\n  gap: var(--ds-space-2);\n}\n\n.shift-planning .rbc-event,\n.shift-planning .rbc-event-label {\n  overflow-wrap: anywhere;\n}\n\n.shift-planning .rbc-addons-dnd .rbc-addons-dnd-resizable {\n  width: 100%;\n}\n\n@media (max-width: 767.98px) {\n  .shift-planning .shift-planning__calendar {\n    padding: var(--ds-space-1);\n  }\n\n  /* Compact toolbar: period label on top, then navigation and view switch, each full width */\n  .shift-planning .rbc-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .shift-planning .rbc-toolbar .rbc-toolbar-label {\n    order: -1;\n    padding: 0;\n    font-weight: 600;\n    text-align: center;\n  }\n\n  .shift-planning .rbc-toolbar .rbc-btn-group {\n    display: flex;\n  }\n\n  .shift-planning .rbc-toolbar .rbc-btn-group > button {\n    flex: 1 1 0;\n    padding-inline: var(--ds-space-1);\n  }\n\n  /* Week and month grids keep their columns and scroll sideways inside the frame */\n  .shift-planning .rbc-time-view,\n  .shift-planning .rbc-month-view {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .shift-planning .is-week .rbc-time-header,\n  .shift-planning .is-week .rbc-time-content {\n    min-width: 640px;\n  }\n\n  .shift-planning .rbc-month-view .rbc-month-header,\n  .shift-planning .rbc-month-view .rbc-month-row {\n    min-width: 560px;\n  }\n}\n\n/* ─── Events ───────────────────────────────────────────────────────────── */\n\n.shift-planning .AbsentEmployee {\n  border: 1px solid var(--sp-error);\n  border-radius: 50%;\n  padding: 2px;\n}\n\n.shift-planning .calendarEvent:has(.AbsentEmployee) {\n  border: 2px solid var(--sp-error);\n}\n\n.shift-planning .DuplicateEmp {\n  border: 1px solid var(--sp-warning);\n  border-radius: 50%;\n  padding: 2px;\n}\n\n.shift-planning .calendarEvent:has(.DuplicateEmp) {\n  border: 2px solid var(--sp-warning);\n}\n\n.shift-planning .calendarEvent.shiftCancelled {\n  opacity: 0.45;\n  text-decoration: line-through;\n  background-image: repeating-linear-gradient(\n    135deg,\n    transparent 0 6px,\n    rgba(255, 255, 255, 0.25) 6px 12px\n  );\n}\n\n.shift-planning .calendarEvent.shiftUnderstaffed {\n  box-shadow: inset 0 0 0 2px var(--sp-error);\n}\n\n.shift-planning .staffCount {\n  white-space: nowrap;\n}\n\n.shift-planning .staffCount.understaffed {\n  background: var(--sp-error);\n  color: var(--sp-on-color);\n  border-radius: 8px;\n  padding: 0 5px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
